import { FormattedMessage, useIntl } from 'react-intl';

import { Row, Col, Form, Input, Select, FormInstance } from 'antd';

import { ReportGroupsFormValues } from '@/core/domain/reports/stock/Report.types';
import AreasInfiniteSelectField from '@/components/_common/AreasInfiniteSelectField';
import { FloatingFormItem } from '@/components/_common';

interface Props {
  form?: FormInstance<ReportGroupsFormValues>;
}

function GroupReportForm({ form }: Props) {
  const intl = useIntl();

  return (
    <Form form={form}>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={8} md={8}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'groups.modal.report.form.description',
            })}
            name="description"
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={8} md={8}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'groups.modal.report.form.areas',
            })}
            name="subArea"
          >
            <AreasInfiniteSelectField allowClear />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={8} md={8}>
          <FloatingFormItem
            name="active"
            label={intl.formatMessage({
              id: 'commons.entity.situation',
            })}
          >
            <Select allowClear style={{ width: '100%' }}>
              <Select.Option value="true">
                <FormattedMessage id="commons.entity.active" />
              </Select.Option>
              <Select.Option value="false">
                <FormattedMessage id="commons.entity.inactive" />
              </Select.Option>
            </Select>
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default GroupReportForm;
